import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

export const monthOptions: Array<ISelectOption<string>> = [
  {
    id: '01',
    label: 'Январь',
    value: 'Январь',
  },
  {
    id: '02',
    label: 'Февраль',
    value: 'Февраль',
  },
  {
    id: '03',
    label: 'Март',
    value: 'Март',
  },
  {
    id: '04',
    label: 'Апрель',
    value: 'Апрель',
  },
  {
    id: '05',
    label: 'Май',
    value: 'Май',
  },
  {
    id: '06',
    label: 'Июнь',
    value: 'Июнь',
  },
  {
    id: '07',
    label: 'Июль',
    value: 'Июль',
  },
  {
    id: '08',
    label: 'Август',
    value: 'Август',
  },
  {
    id: '09',
    label: 'Сентябрь',
    value: 'Сентябрь',
  },
  {
    id: '10',
    label: 'Октябрь',
    value: 'Октябрь',
  },
  {
    id: '11',
    label: 'Ноябрь',
    value: 'Ноябрь',
  },
  {
    id: '12',
    label: 'Декабрь',
    value: 'Декабрь',
  },
];
